module.exports = __webpack_public_path__ + "img/010048.7eeed4f5.png";